import React from 'react';
import CustomStatus from './CustomStatus';
import http from '../../../../../../../utils/http';
import evemts from 'utils/evemts';

class CustomStatusContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      airlineList: [],
      customStatus: [],
      cron: '',
      cron_period: '',
      cron_code: '',
      cron_spl: '',
      cron_spl_period: '',
      cron_spl_interval: '',
      cron_spl_code: '',
      modal: null,
      cronErrors: {},
      statusErrors: {},
      marked_as_cleared: '',
      marked_as_not_cleared: '',
      apiCallCount: null,
    };
    this.eventSource = null;
  }
  componentDidMount() {
    this.fetchCustomStatus();
    this.fetchCronInterval();
    this.fetchCustomStatusCodes();
    this.fetchApiCallCount();
    this.eventSource = evemts('admin', 'import');
    this.eventSource.onmessage = (event) => {
      const msg = JSON.parse(event.data || '{}');

      if (msg.data && msg.action && msg.action == 'airline_config') {
        if (msg.data.type != 'custom_status') return;
        let findIndex = this.state.customStatus.findIndex((status) => status.airlineId == msg.data.airlineId);
        if (findIndex > -1) {
          let customStatus = [...this.state.customStatus];
          customStatus[findIndex] = msg.data;
          this.setState({ customStatus });
        } else {
          this.setState({ customStatus: [...this.state.customStatus, msg.data] });
        }
      }
    };

  }

  componentWillUnmount() {
    if (this.eventSource) {
      this.eventSource.close();
    }
  }

  fetchAirlines = () => {
    http.get('/airline')
      .then((response) => {
        // handle success
        this.setState({ airlineList: response.data.data });
      })
      .catch((error) => {
        // handle error
        console.error('Error fetching airlines:', error);
      });
  };

  fetchCronInterval = () => {
    http.get('/settings?key=custom_status_check_interval').then(({ data }) => {
      if (data.data) {
        let cron = data.data?.find((item) => item.key === 'custom_status_check_interval');
        if (cron) {
          this.setState({
            cron: cron?.value?.time || '',
            cron_period: cron?.value?.period || '',
            cron_code: cron?.value?.code || '',
            cron_spl: cron?.value?.spl || '',
            cron_spl_period: cron?.value?.spl_period || '',
            cron_spl_interval: cron?.value?.spl_interval || '',
            cron_spl_code: cron?.value?.spl_code || ''
          });
        }
      }
    });
  };

  fetchCustomStatusCodes = () => {
    http.get('/settings?key=custom_status_codes').then(({ data }) => {
      if (data.data) {
        let statusCodes = data.data?.find((item) => item.key === 'custom_status_codes');
        if (statusCodes) {
          this.setState({
            marked_as_cleared: statusCodes?.value?.marked_as_cleared || '',
            marked_as_not_cleared: statusCodes?.value?.marked_as_not_cleared || ''
          });
        }
      }
    });
  };

  fetchCustomStatus = () => {
    http.get('/airline_config?type=' + 'custom_status')
      .then((response) => {
        // handle success
        this.setState({ customStatus: response.data.data }, () => {
          this.fetchAirlines();
        });
      })
      .catch((error) => {
        // handle error
        console.error('Error fetching customs status:', error);
      });
  };

  fetchApiCallCount = () => {
    http.get('/customs_city/stats')
      .then((response) => {
        // handle success
        this.setState({ apiCallCount: response.data.data });
      })
      .catch((error) => {
        // handle error
        console.error('Error fetching API call count:', error);
        this.setState({ apiCallCount: { total_api_calls: 0 } });
      });
  };

  onChange = (event) => {
    const { name, checked } = event.target;
    http.post('/airline_config', {
      airlineId: name,
      type: 'custom_status',
      value: checked
    });
  };

  handleOpen = (type) => {
    this.setState({ modal: type });
  };

  onClose = () => {
    this.setState({
      modal: null,
      cronErrors: {},
      statusErrors: {}
    });
  };

  onChangeCron = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  onChangeStatus = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };


  saveCronInterval = (e) => {
    e.preventDefault();
    if (!this.state.cron) {
      this.setState({ cronErrors: { cron: 'Cron interval is required' } });
      return;
    }
    if (!this.state.cron_period) {
      this.setState({ cronErrors: { cron_period: 'Cron period is required' } });
      return;
    }
    if (!this.state.cron_code) {
      this.setState({ cronErrors: { cron_code: 'Customs status code is required' } });
      return;
    }

    http.put('/settings/custom_status_check_interval', {
      value: {
        time: this.state.cron,
        period: this.state.cron_period,
        code: this.state.cron_code,
        spl: this.state.cron_spl,
        spl_code: this.state.cron_spl_code,
        spl_period: this.state.cron_spl_period,
        spl_interval: this.state.cron_spl_interval  
      }
    }).then(({ data }) => {
      if (data.status == 'success') {
        this.setState({
          modal: null,
          cronErrors: {}
        });
      }
    });
  };
  saveStatus = (e) => {
    e.preventDefault();
    if (!this.state.marked_as_cleared) {
      this.setState({ statusErrors: { marked_as_cleared: 'Customs status code to mark as cleared is required' } });
      return;
    }
    if (!this.state.marked_as_not_cleared) {
      this.setState({ statusErrors: { marked_as_not_cleared: 'Customs status code to mark as not cleared is required' } });
      return;
    }
    
    http.put('/settings/custom_status_codes', {
      value: {
        marked_as_cleared: this.state.marked_as_cleared,
        marked_as_not_cleared: this.state.marked_as_not_cleared
      }
    }).then(({ data }) => {
      if (data.status == 'success') {
        this.setState({
          modal: null,
          statusErrors: {}
        });
      }
    });
  };

  render() {
    return (
      <CustomStatus 
        airlineList={this.state.airlineList} 
        customStatus={this.state.customStatus} 
        onChange={this.onChange} 
        handleOpen={this.handleOpen} 
        onClose={this.onClose} 
        cron={this.state.cron} 
        onChangeCron={this.onChangeCron} 
        saveCronInterval={this.saveCronInterval} 
        cronErrors={this.state.cronErrors} 
        modal={this.state.modal} 
        cron_period={this.state.cron_period} 
        cron_code={this.state.cron_code}
        cron_spl={this.state.cron_spl} 
        cron_spl_code={this.state.cron_spl_code} 
        cron_spl_period={this.state.cron_spl_period} 
        cron_spl_interval={this.state.cron_spl_interval}
        marked_as_cleared={this.state.marked_as_cleared}
        marked_as_not_cleared={this.state.marked_as_not_cleared}
        onChangeStatus={this.onChangeStatus}
        saveStatus={this.saveStatus}
        statusErrors={this.state.statusErrors}
        apiCallCount={this.state.apiCallCount}
      />
    );
  }
}

export default CustomStatusContainer;